import {useContext} from 'react';
import pathUtils from '../utils/pathUtils';
import {Trans, useTranslation} from 'react-i18next';
import React from 'react';
import {AuthContext} from '../components/authprovider';
import authUtils from '../utils/authUtils';

export default function usePFSiteLinks() {
  const {i18n} = useTranslation();
  const functionType = pathUtils.isEyewear() ? 'EYEWEAR' : 'MAKEUP';
  const {loaded, loggedIn, ownedFunctionTypes} = useContext(AuthContext);

  const getAboutLink = () => {
    const url = pathUtils.isEyewear() ? '/business/solutions/online-service/eye-wear' : '/business/solutions/online-service';
    return pathUtils.getPFSiteURL(url, i18n.language);
  };

  const getPlanLink = () => {
    const url = `/business/plan?functionType=${functionType}`;
    return pathUtils.getPFSiteURL(url, i18n.language);
  };

  const getFreeTrialLink = () => {
    const url = `/business/user/free-trial?functionType=${functionType}`;
    return pathUtils.getPFSiteURL(url, i18n.language);
  };

  const getSubscribeLink = () => {
    const url = `/business/user/sign-up/premium?platform=STANDARD&recurringType=ANNUAL&currencyType=USD&functionType=${functionType}`;
    return pathUtils.getPFSiteURL(url, i18n.language);
  };

  const _getCTATrialText = () =>
    functionType === 'EYEWEAR' ? (
      <Trans i18nKey="cta.free.trial.eyewear">Build Your Virtual Eyewear Store Now with 30-Day Free Trial</Trans>
    ) : (
      <Trans i18nKey="cta.free.trial.makeup">Build Your Virtual Makeup Store Now with 30-Day Free Trial</Trans>
    );

  const shouldReplaceTrialWithSubscribe = () => loaded && loggedIn && authUtils.ownedCurrentFunctionType(ownedFunctionTypes);

  const shouldReplaceTrialWithPlan = () => loaded && loggedIn && !authUtils.ownedCurrentFunctionType(ownedFunctionTypes);

  const canTrail = () => loaded && (!loggedIn || !authUtils.ownedCurrentFunctionType(ownedFunctionTypes));

  const getTrialButtonContent = () => {
    if (shouldReplaceTrialWithSubscribe()) {
      return {url: getSubscribeLink(), text: <Trans i18nKey="banner.subscribe.now">Subscribe Now</Trans>};
    }
    if (shouldReplaceTrialWithPlan()) {
      return {url: getPlanLink(), text: <Trans i18nKey="banner.start.free.trial">Start Free Trial</Trans>};
    }
    return {url: getFreeTrialLink(), text: <Trans i18nKey="banner.start.free.trial">Start Free Trial</Trans>};
  };

  const getCTAContent = () => {
    if (shouldReplaceTrialWithSubscribe()) {
      return {url: getSubscribeLink(), text: <Trans i18nKey="banner.subscribe.now">Subscribe Now</Trans>};
    }
    if (shouldReplaceTrialWithPlan()) {
      return {url: getPlanLink(), text: _getCTATrialText()};
    }
    return {url: getFreeTrialLink(), text: _getCTATrialText()};
  };

  return {
    getAboutLink,
    getPlanLink,
    getFreeTrialLink,
    getSubscribeLink,
    getTrialButtonContent,
    getCTAContent,
    canTrail,
  };
}
